import React, { useState } from "react";
import { ChevronDownIcon, XMarkIcon } from "@heroicons/react/24/outline";

function ActionHistory({data}) {
  const [open, setOpen] = useState(false);

  return (
    <div>
      <div className="flex justify-between items-center">
        <h2 className="text-[16px] ">Action History</h2>

        <ChevronDownIcon
          onClick={() => setOpen(!open)}
          className={` h-4 cursor-pointer text-[#6C757D]  ${
            open && "rotate-180  h-4 "
          }`}
        />
      </div>
      <div className={`mt-4  ${open ? "block" : "hidden"} `}>
        <div className="relative overflow-x-auto">
          <table className="w-full text-sm  border border-[#6C757D]">
            <thead className="text-sm text-white text-center   bg-[#2563eb] ">
              <tr>
                <th scope="col" className="px-6 py-3 font-normal ">
                  Action by
                </th>
                <th scope="col" className="px-6 py-3 font-normal ">
                  Action Perform
                </th>
                <th scope="col" className="px-6 py-3 font-normal ">
                  Date
                </th>
              </tr>
            </thead>
            <tbody className=" text-center text-[#6C757D] border-t  border-[#6C757D] ">
              {data?.action_history.map(val=>{
               const [date,time] = val?.update_time.split(" ");

               return(
                <tr className="bg-white ">
                <td
                  scope="row"
                  className="px-6 py-4 font-medium  whitespace-nowrap border-r border-[#6C757D] "
                >
                  {val?.name}
                </td>
                <td className="px-6 py-4 border-r border-[#6C757D] ">
                  {val?.action}
                </td>
                <td className="px-6 py-4">{date.split("-").reverse().join("-")} &nbsp; at &nbsp; {time}</td>
              </tr>
               )

              })

              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default ActionHistory;
